export enum EventMode {
    Production = 'production',
    Test = 'test',
    Development = 'development',
    Unknown = 'unknown'
}
export const EventModeName = Object.entries(EventMode).reduce(
    (r, [k, v]) => {
        r[v] = k;
        return r;
    },
    {} as Record<EventMode, string>
);
